"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function DropdownItem(_a) {
    var onChange = _a.onChange, setIsOpened = _a.setIsOpened, getItemLabel = _a.getItemLabel, getItemId = _a.getItemId, value = _a.value, dataCy = _a.dataCy, multiselect = _a.multiselect, item = _a.item, onChangeMultiSelect = _a.onChangeMultiSelect, isFocused = _a.isFocused;
    return (react_1.default.createElement("li", { 
        // for some reason onClick is not working
        onMouseDown: function () {
            if (!multiselect) {
                setIsOpened(false);
                onChange(item);
                return;
            }
            onChangeMultiSelect(item);
        }, title: getItemLabel(item), className: isFocused ? 'focused' : '' },
        react_1.default.createElement("label", { "data-cy": "".concat(dataCy, "-").concat(getItemLabel(item)) }, multiselect ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("input", { type: "checkbox", checked: value &&
                    Array.isArray(value) &&
                    value.find(function (itemToFind) { return getItemId(item) === getItemId(itemToFind); }) !== undefined, onChange: function () { return onChangeMultiSelect(item); } }),
            react_1.default.createElement("span", { className: "checkmark" }),
            react_1.default.createElement("span", { className: "name" }, getItemLabel(item)))) : (react_1.default.createElement("a", null, getItemLabel(item))))));
}
exports.default = DropdownItem;
